import React from "react";
import EventGalleryPage from "../components/EventGalleryPage";
import { eventGalleries } from "../data/galleries";

export default function Weddings() {
  return (
    <EventGalleryPage
      imageLabel="Wedding"
      cloudinaryFolder="images/weddings"
      images={eventGalleries.weddings}
      intro={{
        icon: "💍💒💐",
        title: <>Celebrate Your <strong>I Do</strong> With Elegance</>,
        subtitle: (
          <>
            <p>Your wedding day should be a joyful celebration — not a source of stress. At Fiesta Event Decor, I offer all-inclusive wedding décor services designed to bring your vision to life with ease and elegance.</p>
            <p className="mt-4">As a dedicated wedding designer, I work closely with you to ensure every detail reflects your style and creates a truly unforgettable experience. From planning to setup, you can relax knowing everything is in caring, capable hands.</p>
          </>
        ),
      }}
    />
  );
}
